import type { ReactNode } from 'react';
import { ApiError } from '../api/client.js';
import { useAiStatus } from '../api/queries.js';

export function Loading({ texto = 'Carregando…' }: { texto?: string }) {
  return <p className="py-8 text-center text-sm text-adega-muted">{texto}</p>;
}

export function ErrorBox({ erro }: { erro: unknown }) {
  const mensagem =
    erro instanceof ApiError
      ? erro.message
      : erro instanceof Error
        ? erro.message
        : 'Erro inesperado.';

  return (
    <div className="rounded-xl border border-red-900/60 bg-red-950/40 px-4 py-3 text-sm text-red-200">
      {mensagem}
    </div>
  );
}

export function EmptyState({
  titulo,
  descricao,
  acao,
}: {
  titulo: string;
  descricao: string;
  acao?: ReactNode;
}) {
  return (
    <div className="card text-center">
      <p className="font-semibold">{titulo}</p>
      <p className="mx-auto mt-1 max-w-sm text-sm text-adega-muted">{descricao}</p>
      {acao ? <div className="mt-4 flex justify-center">{acao}</div> : null}
    </div>
  );
}

/**
 * Aviso único de IA não configurada.
 *
 * Aparece no lugar dos recursos de IA em vez de deixar o usuário clicar e
 * tomar erro — a decisão de produto é que o app é plenamente utilizável sem chave.
 */
export function AiConfigBanner({ contexto }: { contexto: string }) {
  const { data: status } = useAiStatus();

  if (!status || status.enabled) {
    return null;
  }

  return (
    <div className="rounded-xl border border-adega-gold/30 bg-adega-gold/10 px-4 py-3 text-sm">
      <p className="font-semibold text-adega-gold">IA não configurada</p>
      <p className="mt-1 text-adega-muted">
        {contexto} Defina <code className="text-adega-text">AI_PROVIDER</code> e a chave
        correspondente no backend para habilitar.
      </p>
    </div>
  );
}
